<template>
	<div @click="goToThread" class="thread-link">
		<img v-if="iconUrl" :src="iconUrl" class="thread-link-icon" alt="" />
		<p>
			{{ name }}
		</p>
		<span @click.stop="threadLinkDelete" class="thread-link-del-wrap">
			<svg-icon class="thread-link-del" name="trash" :size="20" />
		</span>
	</div>
</template>

<script setup lang="ts">
import SvgIcon from '@/components/SvgIcon.vue'

const props = defineProps({
	name: { type: String, required: true },
	id: { type: Number, required: true },
	iconUrl: { type: String, default: '' }
})
const emit = defineEmits<{
	threadLinkDelete: [id: number]
	goToThread: [id: number]
}>()

function threadLinkDelete() {
	emit('threadLinkDelete', props.id)
}

function goToThread() {
	emit('goToThread', props.id)
}
</script>

<style lang="scss" scoped>
.thread-link {
	background-color: var(--background-secondary);
	color: var(--text-primary);
	width: 100%;
	border: 50px;
	padding: 9px 16px;
	@include flex-space-between;
	font: var(--font-label);
	margin-bottom: 8px;
	border-radius: var(--radius-md);
	cursor: pointer;
	transition: $transition-bg;
	&:hover {
		background-color: var(--background-secondary-hover);
	}
	&:active {
		background-color: var(--background-brand-subtle);
	}
	p {
		flex: 1;
	}
	&-icon {
		width: 20px;
		height: 20px;
		object-fit: contain;
		flex-shrink: 0;
		margin-right: 10px;
	}
	&-del {
		&-wrap {
			@include flex-center;
			min-width: 20px;
			width: 20px;
			height: 20px;
			margin-left: 8px;
			color: var(--text-secondary);
			border-radius: 100%;
			transition: $transition-color, $transition-opacity;
			&:hover {
				color: var(--text-secondary-hover);
			}
			&:active {
				color: var(--text-secondary-hover);
			}
		}
	}
}
</style>
